import moment from 'moment'
import i18n from '@/locales'

const isAllNormalNumber = (list) => {
  const fitList = list.filter(key => key === '?' || key === '*')
  return !fitList.length
}
const isAllFitString = (list) => {
  const numberList = list.filter(key => key !== '?' && key !== '*')
  return !numberList.length
}
export const decodeCronExpression = (str, expired_at) => {
  const ret = {
    cycleType: '',
    hourMinute: '',
    description: '',
  }
  const list = str.split(' ')
  const [m, h, d, M, w] = [...list]
  ret.hourMinute = `${h.padStart(2, '0')}:${m.padStart(2, '0')}`
  if (isAllNormalNumber([d, M]) && isAllFitString([w]) && expired_at) {
    const y = moment(expired_at).subtract('hours', 1).format('YYYY')
    ret.cycleType = 'one'
    ret.description = `${y}-${M.padStart(2, '0')}-${d.padStart(2, '0')} ${ret.hourMinute}`
  } else if (isAllNormalNumber([m, h]) && isAllFitString([d, M, w])) {
    ret.cycleType = 'day'
    ret.description = ret.hourMinute
  } else if (isAllNormalNumber([m, h, w]) && isAllFitString([d, M])) {
    ret.cycleType = 'week'
    ret.weekDays = w.split(',')
    ret.description = ret.weekDays.map(key => {
      return i18n.t(`report.cycle_type_week.${key}`)
    }).join(',') + ' ' + ret.hourMinute
  } else if (isAllNormalNumber([m, h, d]) && isAllFitString([w, M])) {
    ret.cycleType = 'month'
    ret.monthDays = d.split(',')
    ret.description = ret.monthDays.map(key => {
      return i18n.t('report.cycle_type_day', [key])
    }).join(',') + ' ' + ret.hourMinute
  } else if (isAllFitString([w]) && isAllNormalNumber([m, h, d, M])) {
    ret.cycleType = 'year'
    ret.yearMonths = M.split(',')
    ret.yearDays = d.split(',')
    ret.description = i18n.t('report.cycle_type_year', [ret.yearMonths, ret.yearDays]) + ' ' + ret.hourMinute
  }
  ret.cycleTypeText = i18n.t(`report.cycle_type.${ret.cycleType}`)
  return ret
}

export const reportUnitTransfer = {
  binaryUnit: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  bpsUnit: ['bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps'],
  isBinaryUnit: function (unit) {
    return unit && this.binaryUnit.includes(unit)
  },
  isBpsUnit: function (unit) {
    return unit && this.bpsUnit.includes(unit)
  },
  getBpsCalc: function (originUnit, targetUnit) {
    let calc = 'x'
    if (this.isBpsUnit(originUnit) && this.isBpsUnit(targetUnit)) {
      const transferLen = this.bpsUnit.findIndex(unit => targetUnit === unit) - this.bpsUnit.findIndex(unit => originUnit === unit)
      if (!transferLen) return calc
      for (let i = 0; i < Math.abs(transferLen); i++) {
        calc += transferLen > 0 ? ' / 1024' : ' * 1024'
      }
    }
    return calc
  },
  getBinaryCalc: function (originUnit, targetUnit) {
    let calc = 'x'
    if (this.isBinaryUnit(originUnit) && this.isBinaryUnit(targetUnit)) {
      const transferLen = this.binaryUnit.findIndex(unit => targetUnit === unit) - this.binaryUnit.findIndex(unit => originUnit === unit)
      if (!transferLen) return calc
      for (let i = 0; i < Math.abs(transferLen); i++) {
        calc += transferLen > 0 ? ' / 1024' : ' * 1024'
      }
    }
    return calc
  },
}
